import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  boxSizing: 'border-box',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  width: '100%',
  '@media (min-width: 600px)': {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3)
  },
  '@media (min-width: 960px)': {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));

export const Section = styled('div', {
  shouldForwardProp: prop => !['fullSize', 'padding', 'margin'].includes(prop)
})(({ theme, fullSize, padding, margin }) => ({
  background: theme.color.background.section,
  ...(fullSize && { flex: '1 1 auto' }),
  ...(padding && { padding: theme.spacing(...padding.split(' ').map(Number)) }),
  ...(margin && { margin: theme.spacing(...margin.split(' ').map(Number)) })
}));

export const MainSection = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 auto',
  overflow: 'hidden',
  zIndex: theme.layer.base
}));
